import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import '../css/magazine-banner.css';

const MagazineBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const closedAt = localStorage.getItem('magazineBannerClosedAt');
    const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
    const stillDismissed = closedAt && (Date.now() - parseInt(closedAt, 10) < sevenDaysMs);
    if (!stillDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('magazineBannerClosedAt', Date.now().toString());
  };

  if (!isVisible) return null;

  return (
    <div className="magazine-banner-modal">
      <div className="magazine-banner-content">
        <div className="magazine-banner-left">
          <div className="magazine-banner-image">
            <img
              src="https://macte-api.ktgp.fr/uploads/Lyannaj_Banner_Web_240320_9afaa13171.jpg"
              alt="Couverture Magazine Lyannaj"
            />
          </div>
          <div className="magazine-banner-text">
            <h3>Nouveau numéro du Magazine Lyannaj</h3>
            <p>Découvrez notre dernière édition maintenant disponible</p>
          </div>
        </div>
        <div className="magazine-banner-right">
          <a href="/magazines" className="magazine-banner-cta">
            Consulter le magazine
          </a>
          <button
            onClick={handleClose}
            className="magazine-banner-close"
            aria-label="Fermer"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MagazineBanner;
